export enum UserRole {
  Tenant = 'TENANT', // Nookster
  IndividualLessor = 'INDIVIDUAL_LESSOR', // Nookian
  Business = 'BUSINESS',
  SuperAdmin = 'SUPER_ADMIN',
  AnonymousTenant = 'ANONYMOUS_TENANT'
}
